import { observer } from 'mobx-react-lite';

import { Subscription, subscriptionStore } from '@/features/subscription';
import { TeamPlanBadge } from '@/features/team/components/TeamPlanBadge';
import type { MemberTier, TeamRole } from '@/features/team/team.types';

import { SettingsSection } from '../settings-section';

export const SubscriptionSettings = observer(() => {
  const teamInfo = subscriptionStore.state.team;

  return (
    <SettingsSection.Root>
      <SettingsSection.Header>
        <SettingsSection.Title>Subscription</SettingsSection.Title>
      </SettingsSection.Header>
      {teamInfo ? (
        <TeamPlanBadge
          teamName={teamInfo.name}
          tier={teamInfo.tier as MemberTier}
          role={teamInfo.role as TeamRole}
        />
      ) : (
        <Subscription />
      )}
    </SettingsSection.Root>
  );
});
